import React from 'react';
import { useNavigate } from 'react-router';
import PersonOutlineSharpIcon from '@mui/icons-material/PersonOutlineSharp';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import { StyledMenu, StyledMenuItem, StyledLogoutMenuItem } from './Header';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';
import { getFontFamily } from '../../../../../apps/table-tuck-web/src/app/Utils/fontLoader';

export function FattyPattyMobileActions({
  userData,
  anchorElProfile,
  handleOpenProfileMenu,
  handleCloseProfileMenu,
  signOut,
  navigate,
}) {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
      }}
    >
      {/* Profile Image/Icon */}
      <div
        style={{
          borderRadius: '50%',
          width: '45px',
          height: '45px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          overflow: 'hidden',
          backgroundColor: '#444',
        }}
        onClick={handleOpenProfileMenu}
      >
        {userData?.profileImage ? (
          <img
            src={userData.profileImage}
            alt="Profile"
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
            }}
          />
        ) : (
          <PersonOutlineSharpIcon
            style={{
              color: 'white',
              fontSize: '24px',
            }}
          />
        )}
      </div>

      {/* Profile Dropdown Menu */}
      <StyledMenu
        id="profile-menu"
        MenuListProps={{
          'aria-labelledby': 'profile-button',
        }}
        anchorEl={anchorElProfile}
        open={Boolean(anchorElProfile)}
        onClose={handleCloseProfileMenu}
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(10px)',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            minWidth: '200px',
            padding: '8px 0',
          },
        }}
      >
        <StyledMenuItem
          onClick={() => {
            navigate('/profile');
            handleCloseProfileMenu();
          }}
          disableRipple
        >
          <PersonOutlineSharpIcon
            style={{
              fontSize: 20,
              color: '#333',
              marginRight: '12px',
            }}
          />
          <span
            style={{
              fontSize: '14px',
              fontWeight: 500,
              color: '#333',
              fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
            }}
          >
            Profile
          </span>
        </StyledMenuItem>
        <Divider style={{ margin: '8px 16px', opacity: 0.3 }} />
        <StyledLogoutMenuItem
          onClick={() => {
            signOut();
            handleCloseProfileMenu();
          }}
          disableRipple
        >
          <ExitToAppIcon
            style={{
              fontSize: 20,
              color: '#f44336',
              marginRight: '12px',
            }}
          />
          <span
            style={{
              fontSize: '14px',
              fontWeight: 500,
              color: '#f44336',
              fontFamily: getFontFamily(environment?.restaurantId, 'jost'),
            }}
          >
            Logout
          </span>
        </StyledLogoutMenuItem>
      </StyledMenu>
    </div>
  );
}

export default FattyPattyMobileActions;
